// components/ShipmentActionBulkCreateScreen.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import BreadcrumbLayout from 'layouts/BreadcrumbLayout';
import ShipmentActionBulkForm from './ShipmentActionBulkForm';
import { useCreateShipmentActionBulkMutation } from 'store/services/shipmentActionApi';

const ShipmentActionBulkCreateScreen = () => {
  const navigate = useNavigate();
  const [createShipmentActionBulk, { isLoading }] = useCreateShipmentActionBulkMutation();

  const breadcrumbs = [
    { title: 'Shipment Actions', path: '/app/crm/action-list/list' },
    { title: 'New Bulk Actions' },
  ];

  const handleCreateShipmentActions = async (actions) => {
    try {
      const response = await createShipmentActionBulk(actions).unwrap();
      toast.success(response.message || 'Shipment actions successfully created!');
      navigate('/app/crm/action-list/list');
    } catch (err) {
      toast.error(
        err?.data?.error || err?.message || 'Couldn’t create shipment actions!'
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <ShipmentActionBulkForm isBusy={isLoading} onSubmit={handleCreateShipmentActions} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ShipmentActionBulkCreateScreen;